import { createSlice, isPending, isRejected, isFulfilled } from '@reduxjs/toolkit';

const globalLoadingSlice = createSlice({
  name: 'globalLoading',
  initialState: {
    pendingRequests: 0 // عدد الـ API calls الجارية
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(isPending, (state) => {
        state.pendingRequests += 1; // عند بداية أي طلب API
      })
      .addMatcher(isFulfilled, (state) => {
        state.pendingRequests -= 1; // عند الانتهاء بنجاح من أي طلب API
      })
      .addMatcher(isRejected, (state) => {
        state.pendingRequests -= 1; // عند فشل أي طلب API
      });
  }
});

export default globalLoadingSlice.reducer;